module.exports = __webpack_public_path__ + "img/Lecture.4a5ffff6.png";